const UpdateDevice = (token, data, id, cb) => {
  fetch(`${process.env.REACT_APP_API}/admin/api/dynamic/devices/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .then((json) => cb(null, json))
    .catch((err) => cb(err, null));
};

export default UpdateDevice;
